"use client";

import type { GtagConsent } from "./types";

export function updateGTMConsent(consent: GtagConsent) {
	if (!window?.gtag) return;
	window.gtag("consent", "update", {
		ad_storage: consent,
		analytics_storage: consent,
		personalization_storage: consent,
		functionality_storage: consent,
		security_storage: consent,
		ad_user_data: consent,
		ad_personalization: consent,
	});
}

export function trackGTMPageView(url: string, gtmId: string) {
	if (!window?.gtag) return;
	window.gtag("config", gtmId, { page_path: url });
}

export function trackGTMGetStartedClicked() {
	window.dataLayer?.push({ event: "get_started_clicked" });
}

export function trackGTMContinueWithGoogleClicked() {
	window.dataLayer?.push({ event: "contine_with_google_clicked" });
}

export function trackGTMUserSignedUp() {
	window.dataLayer?.push({ event: "user_signed_up" });
}

export function trackGTMStripeCheckoutStarted(value: number) {
	window.dataLayer?.push({
		event: "stripe_checkout_started",
		value,
		currency: "USD",
	});
}

export function trackGTMSubscriptionTrialStarted(value: number) {
	window.dataLayer?.push({
		event: "subscription_trial_started",
		value,
		currency: "USD",
	});
}
